import Index from './views/Index'

export default [{
  path: '/partners/:code/dashboard',
  name: 'partner.dashboard',
  component: Index
}]
